export enum ExceptionType {
  GoogleOAuth = "google-oauth",
  Firestore = "firestore",
  Encryption = "encryption",
  OakGoogleClassroom = "oak-google-classroom",
}

export enum ErrorSeverity {
  Error = "error",
  Warning = "warning",
  Info = "info",
}

export interface ErrorContext {
  operation: string;
  service: ExceptionType;
  userId?: string;
  metadata?: Record<string, unknown>;
}

export interface ErrorMapping {
  userMessage: string;
  internalMessage: string;
  shouldRetry: boolean;
  severity: ErrorSeverity;
}

export type OakGoogleClassroomExceptionOptions = {
  code?: string;
  severity?: ErrorSeverity;
  shouldRetry?: boolean;
  context?: ErrorContext;
  originalError?: Error;
};

export type OakGoogleClassroomExceptionObject =
  OakGoogleClassroomExceptionOptions & {
    name: string;
    message: string;
    type: ExceptionType;
  };
